import {observer} from 'mobx-react';
import {Link} from 'react-router-dom';
import UI from '../stores/UI';
import CONTENT from '../stores/Content';
import HELP from '../stores/Help';
import Markdown from '../components/Markdown';
import Picture from '../components/Picture';
import Sheet from '../components/Sheet';
import Marque from '../components/Marque';

const ArticleLink = ({thumbnail, thumbnailText, slug}) => {

  return (
    <a href={`/texts/${slug}`} className="thumbnail outerx8">
      <Picture className="multiply" width={350} src={HELP.getMedia(thumbnail).src} />
      <Markdown className="outerx2 h5" convert={thumbnailText} />
    </a>
  )
}

class Texts extends React.Component {

  constructor(props) {
    super(props)
  }

  render() {

    let feature = CONTENT.currentText;

    return (
      <Sheet order={1} className={'bg-light innerx8'}>
        {feature ? (
          <div>
            <h5 className="txt-c">{feature.fields.title}</h5>
            <article>
              <hgroup className="headline max middle guttersx4 outerx8">
                <h1>{feature.fields.headline}</h1>
                <h5 className="outerx2">{feature.fields.subheader}</h5>
              </hgroup>
              <Markdown className="max middle guttersx4 outerx8 indented" convert={feature.fields.article} />
            </article>
            <div className="txt-c outerx8">
              <Marque />
            </div>
            <div className="max middle outerx12">
              <h2 className="txt-c mbx2">Further Reading</h2>
              <div className="outerx4 cols--center guttersx2">
                {CONTENT.texts.map(({fields}, i) => {
                  return <ArticleLink {...fields} key={fields.slug} />
                })}
              </div>
            </div>
          </div>
        ) : (
          <div>
            <h5 className="txt-c">Loading</h5>
          </div>
        )}
      </Sheet>
    )
  }
}

export default observer(Texts)



// WEBPACK FOOTER //
// ./app/javascript/packs/pages/Texts.js